import { useEffect, useState } from "react";
import { api } from "./api";

// Canonical navigation items. Visibility is controlled from the admin dashboard
// (Settings → Navigation, stored at /api/settings/navigation). Default: all visible.
export const NAV_ITEMS = [
  { key: "archive", to: "/archive", label: "ARCHIVE", footerLabel: "Archive", match: (p, s) => p === "/archive" && s !== "field" },
  { key: "field", to: "/archive?series=field", label: "FIELD", footerLabel: "Field", match: (p, s) => p === "/archive" && s === "field" },
  { key: "practice", to: "/practice", label: "PRACTICE", footerLabel: "Practice", match: (p) => p.startsWith("/practice") },
  { key: "allcity", to: "/all-city", label: "ALL CITY", footerLabel: "All City", match: (p) => p.startsWith("/all-city") },
  { key: "about", to: "/about", label: "ABOUT", footerLabel: "About", match: (p) => p.startsWith("/about") },
];

export function useNavItems() {
  const [visibility, setVisibility] = useState(null);
  useEffect(() => {
    api.get("/settings/navigation").then((r) => {
      const items = r.data?.data?.items;
      if (items && typeof items === "object") setVisibility(items);
    }).catch(() => {});
  }, []);
  return NAV_ITEMS.filter((i) => !visibility || visibility[i.key] !== false);
}
